import { Component } from '@angular/core';
import { AddSubcategoryForm } from '../../../../components/admin-dashboard-component/subcategories/add-subcategory-form/add-subcategory-form';

@Component({
  selector: 'app-admin-add-subcategory',
  imports: [AddSubcategoryForm],
  templateUrl: './admin-add-subcategory.html',
  styleUrl: './admin-add-subcategory.scss',
})
export class AdminAddSubcategory {}
